import {Injectable} from '@angular/core';
import {createMyIdentityFromClaims, HankoService} from '../../sopi/hanko';
import {Router} from '@angular/router';
import {environment} from '../../environments/environment';
import {MyAuthOptions} from '@orga-app/auth/variables';
import {Store} from '@ngrx/store';
import * as authActions from './actions';

@Injectable({providedIn: 'root'})
export class AuthService {

    constructor(private hanko: HankoService, private router: Router,
                private store: Store<any>,
                private config: MyAuthOptions) {

        if (!environment.loginRoute) {
            throw new Error('Login route has not been configured.');
        }

        // this.hanko.instance.onSessionCreated((d) => {
        //     console.info('Session created with JWT claims:', d.claims);
        //     const id = createMyIdentityFromClaims(d.claims);
        //     console.log('authService: sending AuthLoginErfolgreichAction');
        //     this.store.dispatch(authActions.CreateAuthLoginErfolgreichAction(id.identityId));
        // });
    }

    async initAuth() {
        const isValid = await this.hanko.validateSession();

        if (!isValid) {
            await this.router.navigate([this.config.loginRoute], {
                onSameUrlNavigation: 'reload'
            });
        } else {
            console.log('authService: sending AuthLoginErfolgreichAction');
            this.store.dispatch(authActions.CreateAuthLoginErfolgreichAction(this.hanko.myIdentity?.identityId ?? 'unknown'));
        }
    }

    get accessToken(): string {
        return this.hanko.getAccessToken();
    }

    hasValidToken() {
        return this.hanko.isLoggedIn;
    }

    async logout() {
        this.hanko.apiLogout().subscribe(r => {
            this.hanko.logout(r?.external_clients);
            this.hanko.startLogin(true);
        });

        await this.router.navigate([this.config.loginRoute], {
            onSameUrlNavigation: 'reload'
        });
    }

}